import React from "react";
import EmailRestore from "pages/login/email/EmailRestoreContainer";
import Login from "pages/login/LoginContainer";
import RestorePassword from "pages/login/restorePassword/RestorePasswordContainer";
import { Route, Switch,  } from "react-router"; // react-router v4/v5
import useScrollToTop from "../hooks/useScrollToTop";
import useRoutes from "hooks/useRoutes";
import useSession from "hooks/useSession";
import PrivateRoutes from "./PrivateRoutes";

const Routes = (): JSX.Element => {
  useScrollToTop();
  useRoutes();
  useSession();

  return (
    <Switch>
      <Route path="/login" exact component={Login} />
      <Route path="/restore-password" exact component={RestorePassword} />
      <Route path="/restore" exact component={EmailRestore} />
      <Route path="/" component={PrivateRoutes}/>
    </Switch>
  );
};

export default Routes;
